import Url from "@core/scripts/helper/url";
import fetchWithCSRF from "@core/scripts/helper/fetch-with-csrf";

const URL_PREFIX = "/ajax/product-recommendations";

function loadRecommendations(styleId,
                             assetId,
                             isTargetGroupLiving,
                             itemId,
                             presentationTypeId,
                             productSeriesLoaded,
                             productSeriesEnabled,
                             shopTheLookEnabled,
                             outfitsEnabled,
                             shopId) {
    const params = new URLSearchParams({
        styleId,
        isTargetGroupLiving,
        itemId,
        presentationTypeId,
        productSeriesLoaded,
        productSeriesEnabled,
        shopTheLookEnabled,
        outfitsEnabled
    });

    if (assetId) {
        params.append('assetId', assetId);
    }

    const url = Url.toAbsolute(`${URL_PREFIX}/?${params.toString()}`);

    return fetchWithCSRF(url)
        .then(toJsonOrThrow(new Error("response was not okay")))
}

function toJsonOrThrow(error) {
    return (response) => {
        if (response.ok) {
            return response.json();
        }
        throw error;
    };
}

export default {
    loadRecommendations
}